import { getColumnsFromMap, sorterDispatcher } from '@app/utils/table'

import type { MonitoringTypesColumns } from '../types'
import type { TranslationsConfigMonitoringTypesDataSource } from '@app/types/dataSource/TranslationsConfigDataSource'
import type { Column } from '@app/components/base/Table/types'

const columnTitleMap: Record<keyof MonitoringTypesColumns, string> = {
  name: 'Тип мониторинг',
  removeButton: ''
}

const getColumnsOptions = (): Array<Column<MonitoringTypesColumns>> => {
  const columnKeys = Object.keys(columnTitleMap) as Array<keyof MonitoringTypesColumns>

  return columnKeys.map(key => {
    const column: Column<MonitoringTypesColumns> = {
      key,
      width: '100%',
      sorter: (a, b) => sorterDispatcher(a[key], b[key])
    }

    return column
  })
}

const getColumns = (): Array<Column<TranslationsConfigMonitoringTypesDataSource>> =>
  [
    ...getColumnsFromMap<MonitoringTypesColumns>({
      columnTitleMap,
      options: getColumnsOptions()
    })
  ] as Array<Column<TranslationsConfigMonitoringTypesDataSource>>

export default getColumns
